import { useCallback, useEffect, useRef, useState } from 'react';

import { debounce } from 'lodash-es';

import { getWindowSafe } from '@change-corgi/core/window';

type Result = ModelHookResult<{ isTruncated: boolean; ref: React.RefObject<HTMLElement | null> }>;

export function useIsResponseTruncated(): Result {
	const ref = useRef<HTMLElement | null>(null);
	const [isTruncated, setIsTruncated] = useState(false);
	const window = getWindowSafe();

	const measure = useCallback(() => {
		const el = ref.current;
		if (!el) return;
		const truncated = el.scrollHeight > el.clientHeight + 1;
		setIsTruncated(truncated);
	}, []);

	useEffect(() => {
		measure();
		const debouncedMeasure = debounce(measure, 100);

		if (!window) return () => {};

		window.addEventListener('resize', debouncedMeasure);
		return () => {
			window.removeEventListener('resize', debouncedMeasure);
		};
	}, [measure, window]);

	return { data: { isTruncated, ref } };
}
